import dateAdapter from "utils/dateAdapter";

export const SaleCreationDate = ({ original }) => dateAdapter(original, 'LL HH:mm');
